import { Link } from "@tanstack/react-router";
import type { PostLink } from "@/content/postlinks";

/**
 * A single in-body sentence linking to the most relevant blog post.
 * Deliberately prose, not a card or a "related articles" list.
 */
export function PostLinkLine({ link }: { link?: PostLink }) {
  if (!link) return null;
  return (
    <p
      className="mt-6"
      style={{
        color: "rgba(0,47,167,0.74)",
        fontSize: 15.5,
        lineHeight: 1.6,
        maxWidth: "62ch",
        margin: "24px 0 0",
      }}
    >
      {link.before}
      <Link
        to={link.to}
        className="underline underline-offset-4 transition-colors hover:text-[#8a6f3f]"
        style={{ color: "#002FA7" }}
      >
        {link.anchor}
      </Link>
      {link.after}
    </p>
  );
}
